<template>
	<!-- Ginny billetera -->
	<div class="function-app--about about__row bg-white" id="video-about">
        <div class="container">
            <!-- Intro -->
            <div class="function-app--about-title">
                <div
                    class="about--section-title text-center fast"
                    v-scroll="handleScroll"
                    data-scroll-class="animated fadeInDown"
                    data-scroll-button-distance="400"
                    data-scroll-once="true">
                    <h1>¿Qué es ginny?</h1>
                </div>
                <div class="video--container embed-responsive ">
                    <youtube-wrapper url="https://www.youtube.com/watch?v=1FwPLu-yj4I" />
                </div>
            </div>
        </div>
	</div>
</template>

<script>
import YoutubeWrapper from "./YoutubeWrapper";

export default {
    name: "AboutVideo",
    components: {
        YoutubeWrapper
    }
};
</script>


<style lang="scss" scoped>
.function-app--about {
    overflow: hidden;
    background: url("../assets/images/bg-3.png");
    background-position: 0px bottom;
    background-repeat: no-repeat;
    background-size: contain;
    padding: 40px;

    @media (min-width: 2000px) {
        background-size: cover;
    }

    &.bg-white {
        background-color: #fff;
    }

    h1,
    h5 {
        font-family: $primary-font;
        font-size: $large-font-size;
        color: $primary-color;
        margin-bottom: 1rem;
    }

    .function-app--about-title {
        font-size: $extra-small-font-size;
        padding-bottom: 80px;

        .about--section-title {
            padding: 80px 0 20px;
        }
    }

    &.about__row {
        margin: 0 -15px;
    }

    .video--container {
        max-width: 723px;
        margin: 0 auto;

        .html5-video-player::v-deep {
            background-color: transparent;
        }
    }
}

// Medium devices (desktop, 991px)
@media screen and (max-width: 991px) {
    .function-app--about {
        padding: 120px 40px;
        .function-app--about-title {
            padding-bottom: 0;

            .about--section-title {
                padding: 0px 0 20px;
            }

            p {
                font-size: $mobile-small-font-size;
                margin-bottom: 0;
            }
        }
    }
}

@media screen and (max-width: 375px) {
    .function-app--about {
        padding: 120px 10px;
    }
}
</style>
